export default __webpack_public_path__ + "static/media/5.f0a37ec3.png";